module.exports = __webpack_public_path__ + "static/media/24-4.e5b9a274.mp3";